module.exports = __webpack_public_path__ + "static/usa-scaled-70c5b93f77dc6bfc1e95f3007ce2f5a6.webp";